const API_URL = process.env.API_URL || 'https://api-hotmart-jobs.buildstaging.com'
const API_URL_INTERNAL = process.env.API_URL_INTERNAL || 'https://api-hotmart-jobs-internal.buildstaging.com'

const WRITE_METHODS = ['post', 'put', 'patch', 'delete']

export const getConfig = ({ method = 'get' } = {}) => {
  const isWriteOperation = WRITE_METHODS.includes(method.toLowerCase())

  return {
    baseURL: `${isWriteOperation ? API_URL_INTERNAL : API_URL}/api/v2`,
    headers: {
      'Content-Type': 'application/json',
    },
    endpoints: {
      jobs: `/jobs`,
      offices: `/offices`,
    },
    driver: 'axios',
  }
}
